import type { AuthorizedResourceAccessMap } from './adapter';

export const hasResourceAccess = (
  accessMap: AuthorizedResourceAccessMap | undefined,
  resourceCode: string,
) => Boolean(accessMap?.[resourceCode]);

export const hasActionAccess = (
  accessMap: AuthorizedResourceAccessMap | undefined,
  resourceCode: string,
  actionCode: string,
) => Boolean(accessMap?.[`${resourceCode}:${actionCode}`]);
